<template>
  <section
    data-qa="analyses_hero_section"
    class="analyses-hero rounded-lg"
  >
    <div
      :class="[
        'd-flex flex-nowrap flex-column align-center justify-space-between ga-6 py-8 px-6 position-relative',
        'flex-sm-row align-sm-stretch ga-sm-4 pa-sm-8 pl-sm-8 pr-sm-0',
      ]"
    >
      <div
        class="d-flex flex-column flex-grow-1 gr-6 gr-sm-4 min-w-0"
      >
        <div class="d-flex flex-column gr-6">
          <h1
            data-qa="analyses_hero_title"
            class="text--text mb-0"
            :class="isMobile ? 'text-h6' : 'text-stat-item'"
          >
            Анализы в {{ townNamePred }}
          </h1>

          <p
            data-qa="analyses_hero_subtitle"
            class="text-body-1 text-secondary--text mb-0"
          >
            <!-- eslint-disable-next-line -->
            Найдите, где сдать анализы, сравните цены в клиниках и лабораториях<template v-if="context.is_analyses_appointment_available_in_town">, оплатите онлайн со скидкой</template>
          </p>
        </div>

        <AnalysesHeroSearch v-if="context.feature_flags.ff_analyses_search" />

        <div
          v-if="popularAnalyses.length"
          class="analyses-hero__popular d-flex flex-column flex-sm-row flex-sm-nowrap ga-2 min-w-0"
        >
          <span class="text-body-2 text-secondary--text flex-shrink-0">
            Популярные анализы
          </span>

          <div class="analyses-hero__popular-tags d-flex flex-nowrap flex-sm-wrap ga-2 min-w-0">
            <a
              v-for="analysis in popularAnalyses"
              :key="analysis.name"
              :href="analysis.href"
              data-qa="analyses_hero_popular_tag"
              class="analyses-hero__tag d-inline-flex align-center rounded-pill px-3 py-1 text-body-2 primary--text text-decoration-none flex-shrink-0"
            >
              {{ analysis.name }}
            </a>
          </div>
        </div>
      </div>

      <img
        :src="`${staticPath}_v1/pd/pictures/analyzes/hero-microscope.png`"
        alt=""
        class="analyses-hero__illustration flex-shrink-0"
      >
    </div>
  </section>
</template>

<script setup lang="ts">
import type { PopularAnalysis } from 'src/components/pages/[town-translit]/diagnostika/analiz/components/types'
import AnalysesHeroSearch from 'src/components/pages/[town-translit]/diagnostika/analiz/components/AnalysesHeroSearch.vue'
import useContextStore from 'src/store/useContextStore'

const { context } = useContextStore()
const { src: staticPath } = context.global.static
const isMobile = context.flavour === 'mobile'

withDefaults(defineProps<{
  townNamePred: string
  popularAnalyses?: PopularAnalysis[]
}>(), {
  popularAnalyses: () => [],
})
</script>

<style lang="scss" scoped>
@import 'src/styles/variables';
@import 'src/styles/mixins';

.analyses-hero {
  background: $bg-light-blue-gradient;

  &__illustration {
    width: 380px;
    max-width: 38%;
    height: auto;
    object-fit: contain;
    pointer-events: none;
    user-select: none;
  }

  &__tag {
    border: 1px solid $ui-kit-primary;

    &:hover {
      opacity: 0.85;
    }
  }
}

@include media-breakpoint-down(sm) {
  .analyses-hero {
    &__illustration {
      display: none;
    }

    &__popular-tags {
      overflow-x: auto;
      margin-right: -32px;
      padding-right: 32px;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
}
</style>
